
export type GetCourseReviewsSort = typeof GetCourseReviewsSort[keyof typeof GetCourseReviewsSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseReviewsSort = {
  latest: 'latest',
  highest: 'highest',
  lowest: 'lowest',
  helpful: 'helpful',
} as const;
